import { render, staticRenderFns } from "./Courses.vue?vue&type=template&id=5a202df6&scoped=true"
import script from "./Courses.vue?vue&type=script&lang=js"
export * from "./Courses.vue?vue&type=script&lang=js"
import style0 from "./Courses.vue?vue&type=style&index=0&id=5a202df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a202df6",
  null
  
)

export default component.exports